export const filledFormData = {
  'registration': {
    'schoolName': 'testas',
    'schoolYear': '2025 / 2026 m.m.',
    'adaptationPeriod': 'I pusmetis',
    'student': 'testuojamas',
    'birthYear': 1999,
    'eduSpecialist': 'testuotojas',

    'grade': '6 Klasė',
    'selectedSubject': 'Tautinės mažumos gimtoji kalba ir literatūra',
    'selectedSubjectInput': 'text from mock',
  },
};
